/**
 * Table of Contents - Exact structure from PDF Contents (pages 3-5).
 * Tree structure: section > subsection > leaf items.
 * path: URL slug for routing
 * label: Display text (matches PDF)
 */
export const TOC = [
  {
    path: "1-introduction",
    label: "1 Introduction",
  },
  {
    label: "2 Installation",
    children: [
      {
        label: "2.1 Installation",
        children: [
          { path: "2-1-1-overview", label: "2.1.1 Overview" },
          { path: "2-1-2-upgrade", label: "2.1.2 Upgrade to a new SEPM Version" },
          { path: "2-1-3-license", label: "2.1.3 License, Path to directory holding SEPM licenses" },
          { path: "2-1-4-module-sw4", label: "2.1.4 Module x_translator_customer (Smallworld 4)" },
          { path: "2-1-5-module-sw5", label: "2.1.5 Module x_translator_customer (Smallworld 5)" },
          { path: "2-1-6-jar-magik", label: "2.1.6 Understanding Jar versus Magik Precedence in SEPM" },
          { path: "2-1-7-product-ser", label: "2.1.7 Loading Time Optimization (file product.ser)" },
          { path: "2-1-8-swaf-xml", label: "2.1.8 Configure SWAF application XML files" },
          { path: "2-1-9-database", label: "2.1.9 X-Translator Database" },
          { path: "2-1-10-database-install", label: "2.1.10 Install/Upgrade of the X-Translator Database" },
          { path: "2-1-11-database-ace", label: "2.1.11 X-Translator Database - ACE" },
          { path: "2-1-12-database-style", label: "2.1.12 X-Translator Database - Style" },
          { path: "2-1-13-wgs84", label: "2.1.13 WGS84 Coordinate System" },
        ],
      },
      {
        label: "2.2 Configuration",
        children: [
          { path: "2-2-1-settings", label: "2.2.1 Settings in x_translator_settings.magik" },
          { path: "2-2-2-formats", label: "2.2.2 List of Formats" },
          { path: "2-2-3-user-formats", label: "2.2.3 Configuration of User-Visible Formats" },
          { path: "2-2-4-gui-defaults", label: "2.2.4 GUI Defaults" },
          { path: "2-2-5-default-values", label: "2.2.5 Default Values in Source and Target Dialogs" },
          { path: "2-2-6-x-base-settings", label: "2.2.6 Settings in x_base_settings.magik" },
          { path: "2-2-7-options-menu", label: "2.2.7 Default values in the options menu" },
          { path: "2-2-8-override-path", label: "2.2.8 Override default Path directory shown in dialogs" },
          { path: "2-2-9-authorisation", label: "2.2.9 Authorisation" },
        ],
      },
      {
        label: "2.3 Coordinate Systems",
        children: [
          { path: "2-3-1-prj-files", label: "2.3.1 Creation of prj-files (Shape Export)" },
          { path: "2-3-2-mif-export", label: "2.3.2 CoordSys-Information (MIF-Export)" },
          { path: "2-3-3-inconsistent", label: "2.3.3 Message \"Inconsistent Coordinate System\"" },
        ],
      },
      {
        label: "2.4 DXF Configurations",
        children: [
          { path: "2-4-1-dxf-api", label: "2.4.1 DXF Configuration API" },
          { path: "2-4-2-dxf-examples", label: "2.4.2 DXF Configuration API Examples" },
          { path: "2-4-3-style-mapping", label: "2.4.3 Message \"No entry in x_translator_settings.dxf_style_mapping for: xxx\"" },
        ],
      },
      {
        label: "2.5 Simple GUI",
        children: [
          { path: "2-5-1-registration", label: "2.5.1 Registration of a Simple GUI Configuration" },
          { path: "2-5-2-gui-items", label: "2.5.2 Available User-Interface Items (gui_items)" },
          { path: "2-5-3-properties", label: "2.5.3 Properties of the Simple GUI Method" },
        ],
      },
      {
        label: "2.6 Reframe-ACP",
        children: [
          { path: "2-6-1-overview", label: "2.6.1 Overview" },
          { path: "2-6-2-installation", label: "2.6.2 Installation" },
          { path: "2-6-3-use", label: "2.6.3 Use" },
        ],
      },
      {
        label: "2.7 DwgAcp (RealDWG™-based AutoCAD DWG/DXF Format)",
        children: [
          { path: "2-7-1-prerequisites", label: "2.7.1 Prerequisites (SEPM 2025-01 and newer)" },
          { path: "2-7-2-installation", label: "2.7.2 Installation" },
          { path: "2-7-3-note-install", label: "2.7.3 Note on installation from version 2025-01" },
          { path: "2-7-4-verification", label: "2.7.4 Verification / Troubleshooting" },
          { path: "2-7-5-upgrade", label: "2.7.5 Upgrade" },
        ],
      },
    ],
  },
  {
    label: "3 Troubleshooting & Support",
    children: [
      {
        label: "3.1 Hotfix Installation and Maintenance",
        children: [
          { path: "3-1-1-overview", label: "3.1.1 Overview" },
          { path: "3-1-2-downloading", label: "3.1.2 Downloading Patches and Hotfixes" },
          { path: "3-1-3-installing-sw5", label: "3.1.3 Installing the Hotfixes (Smallworld 5)" },
          { path: "3-1-4-installing-sw4", label: "3.1.4 Installing the Patches (Smallworld 4)" },
        ],
      },
      {
        label: "3.2 Tickets",
        children: [
          { path: "3-2-1-checklist", label: "3.2.1 Checklist for Submitting a Ticket" },
        ],
      },
      {
        label: "3.3 Configuration Pitfalls",
        children: [
          { path: "3-3-1-misconfigured-csys", label: "3.3.1 Misconfigured Coordinate Systems" },
        ],
      },
      {
        label: "3.4 Citrix-Environments",
        children: [
          { path: "3-4-1-redirecting-logs", label: "3.4.1 Redirecting Log Files" },
        ],
      },
    ],
  },
  {
    label: "4 Logging and Diagnostics",
    children: [
      {
        label: "4.1 Classification of Log Messages",
        children: [
          { path: "4-1-1-overview", label: "4.1.1 Overview" },
          { path: "4-1-2-default-behavior", label: "4.1.2 Default Behavior" },
          { path: "4-1-3-customizing", label: "4.1.3 Customizing Log Message Severity" },
          { path: "4-1-4-implementation", label: "4.1.4 Current Implementation" },
          { path: "4-1-5-use-cases", label: "4.1.5 Use Cases & Best Practices" },
        ],
      },
      {
        label: "4.2 Mapping",
        children: [
          { path: "4-2-1-configuration", label: "4.2.1 Configuration" },
          { path: "4-2-2-error-logs", label: "4.2.2 Mapping Error Logs" },
        ],
      },
    ],
  },
  {
    label: "5 Configuration and API",
    children: [
      {
        label: "5.1 X-Translator API",
        children: [
          { path: "5-1-1-engine", label: "5.1.1 X-Translator Engine" },
          { path: "5-1-2-specifications", label: "5.1.2 X-Translator Specification Classes" },
          { path: "5-1-3-mapping", label: "5.1.3 X-Translator Mapping" },
          { path: "5-1-4-options", label: "5.1.4 X-Translator Options" },
          { path: "5-1-5-error-handling", label: "5.1.5 Error Handling, Progress Conditions" },
          { path: "5-1-6-dxf-api", label: "5.1.6 DXF-API" },
          { path: "5-1-7-registered-attrs", label: "5.1.7 Registered Attributes" },
          { path: "5-1-8-registered-geoms", label: "5.1.8 Registered Geometries" },
        ],
      },
      {
        label: "5.2 Examples",
        children: [
          { path: "5-2-1-export-mapping", label: "5.2.1 \"Export of a saved mapping\"" },
          { path: "5-2-2-change-property", label: "5.2.2 \"Change the property of a specification object\"" },
          { path: "5-2-3-change-option", label: "5.2.3 \"Change the value of an option\"" },
          { path: "5-2-4-batch-import", label: "5.2.4 \"Batch Import of DWG/DXF files\"" },
          { path: "5-2-5-create-specs", label: "5.2.5 \"Create specifications from scratch\"" },
          { path: "5-2-6-shape-to-oracle", label: "5.2.6 Importing a multi-part Shape file to Oracle" },
        ],
      },
      {
        label: "5.3 User Applications",
        children: [
          { path: "5-3-1-overview", label: "5.3.1 Overview" },
          { path: "5-3-2-properties", label: "5.3.2 Properties" },
          { path: "5-3-3-example", label: "5.3.3 Example" },
        ],
      },
    ],
  },
];
